module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBold.4fc7f16.woff";